<template>
  <section>
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="challenges"
        sortBy="id"
        orderBy="asc"
        :columns="tableColumns"
        :isSingleRowDetail="true"
        @sort="setOrder"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
      >
        <template v-slot:tbody="props">
          <th scope="row">{{ props.row.name }}</th>
          <td class="z-column-140-center">
            {{ formatDate(props.row.progress_date) }}
          </td>
          <td class="z-column-110-right">
            {{ formatNumber(props.row.progress.week_progress) }}
          </td>
          <!-- <td class="z-column-110-right">
            {{ formatNumber(props.row.progress.progress_percent) }}
          </td> -->
          <td class="z-column-110-right">
            {{ formatNumber(props.row.progress.total) }}
          </td>
          <td class="z-column-110-right">
            {{ formatNumber(props.row.progress.progress) }}
          </td>
        </template>
        <template v-slot:detail="props">
          <challenge-record :recordData="props.row" />
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import ChallengeRecord from './challenge-record'
export default {
  name: 'challenge',
  components: {
    ZTable,
    ChallengeRecord,
  },
  computed: {
    ...mapGetters('usercardio', ['challengeStats']),
    tableColumns() {
      let columns = [
        {
          field: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          field: 'end_date',
          label: 'Ending',
          sortable: true,
          class: 'z-column-140-center',
        },
        {
          field: 'week_progress',
          label: 'Weekly %',
          sortable: false,
          class: 'z-column-110-right',
        },
        // {
        //   field: 'day_progress',
        //   label: 'Daily %',
        //   sortable: false,
        //   class: 'z-column-110-right',
        // },
        {
          field: 'total_progress',
          label: 'Total %',
          sortable: false,
          class: 'z-column-110-right',
        },
        {
          field: 'challenge_score',
          label: 'Score %',
          sortable: false,
          class: 'z-column-110-right',
        },
      ]
      return columns
    },
    challenges() {
      let _data = []
      if (this.challengeStats) {
        this.challengeStats.forEach((element) => {
          let item = {
            id: element.id,
            name: element.name,
            startDate: moment(element.start_date).format('MM/DD/YYYY'),
            endDate: moment(element.end_date).format('MM/DD/YYYY'),
            closed: element.closed,
            progress: {
              created_at: null,
              goal: null,
              progress: null,
              progress_date: null,
              progress_percent: null,
              rule: null,
              total: null,
              week_progress: null,
            },
            subprogress: [],
            isDetailVisible: false,
          }
          if (element.progress) {
            if (element.progress.length > 0) {
              let found = element.progress.find((x) => x.rule === null)
              if (found) {
                item.progress = found
              }
              let filtered = element.progress.filter((x) => x.rule !== null)
              if (filtered) {
                item.subprogress = filtered
              }
            }
          }
          _data.push(item)
        })
      }
      return _data
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY')
    },
    formatNumber(number) {
      let result = null
      if (number) {
        result = parseFloat(number).toFixed(1)
      }
      return result
    },
    setOrder() {},
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 15px;
}
</style>
